import { render } from "./DiffManchesterPage.vue?vue&type=template&id=507cea2c&scoped=true"
import script from "./DiffManchesterPage.vue?vue&type=script&lang=js"
export * from "./DiffManchesterPage.vue?vue&type=script&lang=js"

import "./DiffManchesterPage.vue?vue&type=style&index=0&id=507cea2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507cea2c"]])

export default __exports__